import { translate } from 'App/Internationalization';
import { withAgentService } from 'service-container';
import { withSettings } from './SettingProvider/SettingProvider';
import captureError from 'utils/captureError';
import flags from '../shared/Flags';
import Loading from '../shared/Loading';
import paths from '../config/local/paths';
import React from 'react';
import ShareableLink from './ShareableLink';

/**
 * @typedef {import('./ShareableLinksCardState').default} State
 * @typedef {import('./ShareableLinksCardProps').default} Props
 */

/** @extends {React.Component<Props, State>} */
export class ShareableLinksCard extends React.Component {
	/** @param {Props} props */
	constructor(props) {
		super(props);

		/** @type {State} */
		this.state = {
			isGettingData: true,
			slug: null,
		};
	}

	async componentDidMount() {
		try {
			const response =
				await this.props.agentService.getAgentPersonalData();

			this.setState({ isGettingData: false, slug: response.slug });
		} catch (error) {
			captureError(error);
			this.setState({ isGettingData: false });
		}
	}

	renderLinks() {
		const base = `${window.location.protocol}//${window.location.hostname}/${this.state.slug}`;

		const linkList = [
			{
				label: translate('agent.pages.dashboard.links.register'),
				url: base + paths.register.homeowner,
			},
			{
				label: translate('agent.pages.dashboard.links.sign_in'),
				url: base + paths.auth.signIn,
			},
		];

		const hasPublicPros =
			this.props.settings.features.get(flags.agent.publicPros) === true;
		const marketplaceFlagEnabled =
			this.props.settings.features.get(flags.agent.marketplaceWidget) ===
			true;
		const hasMarketplaceAccess =
			!marketplaceFlagEnabled ||
			this.props.settings.isEnabled(
				flags.agent.marketplaceWidget,
				'agent_tier'
			);

		if (hasPublicPros && hasMarketplaceAccess) {
			linkList.push({
				label: translate('agent.pages.dashboard.links.vendors'),
				url: base + paths.marketplace,
			});
		}

		if (this.props.settings.isEnabled(flags.agent.blogLink, 'agent_tier')) {
			linkList.push({
				label: translate('agent.pages.dashboard.links.blog'),
				url: base + paths.blog,
			});
		}

		return linkList.map((link) => (
			<ShareableLink
				className="mb-4"
				key={link.url}
				label={link.label}
				url={link.url}
			/>
		));
	}

	render() {
		if (this.state.isGettingData) {
			return <Loading />;
		}

		return (
			<section className="mt-10">
				<h1 className="h-ms-3">
					{translate('agent.pages.dashboard.links.title')}
				</h1>
				<ul className="sharable-urls-list list-group mt-4">
					{this.renderLinks()}
				</ul>
			</section>
		);
	}
}

export default withAgentService(withSettings(ShareableLinksCard));
